import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import UrlHelper from "../../utilities/UrlHelper";
import ValidationHelper from "../../utilities/ValidationHelper";
import SetPassword from "./setPassword/SetPassword";
import SetPin from "./setPassword/SetPin";
import CompleteAccountSetup from "./CompleteAccountSetup";
import ticketType from "../../entities/TicketType";

export class SetPasswordPage extends Component {
    constructor (props) {
        super(props);

        this.state = {
            errorMessage: undefined
        };

        this.handleComplete = this.handleComplete.bind(this);
        this.onStartClick = this.onStartClick.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");
        const ticket = UrlHelper.getParameterByName("ticket");
        if (!ValidationHelper.isNullOrEmpty(ticket))
            this.props.validateVirtualUserTicket(ticket);
    }

    handleComplete (password) {
        const ticket = UrlHelper.getParameterByName("ticket");
        if (!ValidationHelper.isNullOrEmpty(ticket))
            this.props.setPassword(ticket, this.props.pin, password);
    }

    onStartClick () {
        if (this.props.redirectLocationOnSuccess)
            window.location = this.props.redirectLocationOnSuccess;
    }

    render () {
        if (this.props.redirectLocationOnError) {
            window.location = this.props.redirectLocationOnError;
        }

        const redirectLocationOnSuccess = this.props.redirectLocationOnSuccess;
        const pinValidated = this.props.pinValidated;
        const title = "Account Setup Completed";
        const text = "You’re all set! From now on you can access any SoleSource product using this email address.";
        return (
            <div>
                {!pinValidated &&
                <SetPin
                    serverError={this.props.errorMessage}
                    email={this.props.email}
                    validatePin={this.props.validatePin}
                    errorSummary={this.props.errorCode}/>}
                {!redirectLocationOnSuccess && pinValidated &&
                <SetPassword
                    passwordRequirements={this.props.passwordRequirements}
                    passwordValidationUserData={this.props.passwordValidationUserData}
                    onComplete={this.handleComplete}
                    serverError={this.props.errorMessage}
                    isPasswordSetting={this.props.isPasswordSetting}
                    email={this.props.email}/>}
                {redirectLocationOnSuccess && pinValidated &&
                <CompleteAccountSetup
                    title={title}
                    text={text}
                    onComplete={this.onStartClick}
                    email={this.props.email}
                    completeButtonTitle="Get Started"/>}
            </div>
        );
    }
}

SetPasswordPage.defaultProps = {
    validateVirtualUserTicket: () => {},
    validatePin: () => {}
};

SetPasswordPage.propTypes = {
    setPassword: PropTypes.func,
    validateVirtualUserTicket: PropTypes.func,
    errorMessage: PropTypes.string,
    errorCode: PropTypes.string,
    email: PropTypes.string,
    passwordValidationUserData: PropTypes.object,
    passwordRequirements: PropTypes.object,
    redirectLocationOnSuccess: PropTypes.string,
    redirectLocationOnError: PropTypes.string,
    pin: PropTypes.string,
    pinValidated: PropTypes.string,
    validatePin: PropTypes.func,
    isPasswordSetting: PropTypes.bool
};

const mapStateToProps = state => ({
    errorMessage: state.setPasswordState.errorMessage,
    errorCode: state.setPasswordState.errorCode,
    email: state.setPasswordState.email,
    passwordValidationUserData: state.setPasswordState.passwordValidationUserData,
    passwordRequirements: state.setPasswordState.passwordRequirements,
    redirectLocationOnSuccess: state.setPasswordState.redirectLocationOnSuccess,
    redirectLocationOnError: state.setPasswordState.redirectLocationOnError,
    pin: state.setPasswordState.pin,
    pinValidated: state.setPasswordState.pinValidated,
    isPasswordSetting: state.setPasswordState.isPasswordSetting
});

const mapDispatchToProps = (dispatch) => {
    return ({
        setPassword: (ticket, pin, password) => dispatch(actions.setPassword(ticket, pin, password)),
        validateVirtualUserTicket: (ticket) => dispatch(actions.validateVirtualUserTicket(ticket, ticketType.virtualUser.activateAccount.value)),
        validatePin: (pin, ticket) => dispatch(actions.validatePin(pin, ticket))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(SetPasswordPage);
